module.exports = __webpack_public_path__ + "img/3.c88d886c.jpg";